<kendo-dialog
  title="Add Subscription"
  [width]="520"
  [minWidth]="340"
  (close)="close.emit()"
>
  <div class="mb-3">
    <label class="form-label small text-muted mb-1">Service</label>
    <select
      class="form-select"
      [formControl]="productId"
      (change)="selectedId.set(productId.value)"
    >
      <option
        value=""
        disabled
      >Select a service…</option>
      @for (p of products(); track p.product_id) {
        <option [value]="p.product_id">{{ p.display_name }} ({{ p.sku }})</option>
      }
    </select>
  </div>

  <div class="mb-2">
    <label class="form-label small text-muted mb-1">Contracted Count</label>
    <input
      type="number"
      min="0"
      step="1"
      class="form-control"
      [formControl]="count"
    />
  </div>

  @if (selected(); as s) {
    <div class="small text-muted">
      Rate: {{ s.base_rate | currency: s.currency : 'symbol' : '1.2-2' }} — resolved from the parent's rate card
    </div>
  }

  <kendo-dialog-actions>
    <button
      kendoButton
      (click)="close.emit()"
      [disabled]="saving()"
    >Cancel</button>
    <button
      kendoButton
      [themeColor]="'primary'"
      (click)="submit()"
      [disabled]="productId.invalid || count.invalid || saving()"
    >Add</button>
  </kendo-dialog-actions>
</kendo-dialog>
